import React from 'react';
import {connect} from "react-redux";
import {Calendar} from "antd";
import {injectIntl} from "react-intl";
import withAuthorization from "../../../services/Authorization";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import moment from 'moment';
import SetRentalsMenu from "./SetRentalsMenu";
import Constants from "../../../services/Constants";
import Time from "../../../services/Time";

class RentalPlanning extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      setRentalsModalOpen: false,
      selectedDay: moment().format(Constants.DATE_FORMAT_API),
      rentingManual: true,
      hasBicycle: false,
      hasEBike: false,
      hasMotorbike: false,
      planning: {}
    };
  }

  componentDidMount() {
    if (this.state.configurationHints && (this.state.configurationHints.includes("MOBILITY") || this.state.configurationHints.includes("MAIN_SERVICES"))) {
      return;
    }
    if (this.props.saveRentalPlanning.error) {
      this.props.saveRentalPlanning.error = {};
    }
    this.props.dispatchFetchRentalPlanning(this.state.selectedDay);
    this.props.dispatchFetchRentalVehicles();
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.fetchMainServices && nextProps.fetchMainServices.mainServices && !nextProps.fetchMainServices.loading) {
      this.setState({rentingManual: nextProps.fetchMainServices.mainServices.manualRentalCarPlanning})
    }
    if (nextProps.fetchMobility && nextProps.fetchMobility.mobility && nextProps.fetchMobility.mobility.otherMobility && !nextProps.loading) {
      const bicycle = nextProps.fetchMobility.mobility.otherMobility["bicycle"] || {};
      const car = nextProps.fetchMobility.mobility.categoryMobility || {};
      const eBike = nextProps.fetchMobility.mobility.otherMobility["eBike"] || {};
      const motorbike = nextProps.fetchMobility.mobility.otherMobility["motorbike"] || {};

      this.setState({
        hasBicycle: bicycle.active,
        hasCar: car.category1.active || car.category2.active || car.category3.active || car.category4.active,
        hasEBike: eBike.active,
        hasMotorbike: motorbike.active
      });
    }
    if (nextProps.configurationHints) {
      this.setState({configurationHints: nextProps.configurationHints})
    }
  };

  save = () => {
    this.props.dispatchSaveRentalPlanning({planning: this.state.planning});
  };

  updateCalendarRange = (date) => {
    if (moment(this.state.selectedDay).year() !== moment(date).year()) {
      this.props.dispatchFetchRentalPlanning(moment(date).format(Constants.DATE_FORMAT_API));
    }
  };

  onSelectDate = (date) => {
    this.updateCalendarRange(date);
    this.setState({
      selectedDay: moment(date).format(Constants.DATE_FORMAT_API),
      setRentalsModalOpen: this.isOpeningDay(date) && this.state.rentingManual
    });
  };

  dateFullCellRender = (date) => {
    const {fetchRentalPlanning: {rentalPlanning: {planning: initialPlanning = {}}, rentalPlanning}} = this.props;
    const {planning} = this.state;

    const currentDay = moment(date).format("D");
    const formattedDate = moment(date).format(Constants.DATE_FORMAT_API);

    const currentData = planning[formattedDate] || initialPlanning[formattedDate] || {};
    const currentRentals = initialPlanning[formattedDate] || {};
    const colorClass = this.computeCellColor(date, currentData, currentRentals, rentalPlanning);

    return (
      <div className={colorClass + " ant-fullcalendar-date"}>
        <div className="cell">
          <div className="corner tr">
            {currentDay}
          </div>
          {this.renderAvailabilities(date, currentData, currentRentals, rentalPlanning)}
        </div>
      </div>
    )
  };

  computeCellColor = (day, data, currentRentals, rentalPlanning) => {
    if (Time.beforeToday(day)) {
      return "calendar-box--expired";
    }
    if (!this.isOpeningDay(day)) {
      return "";
    }
    const {
      maxRentalBicycles = rentalPlanning.maxRentalBicycles,
      maxRentalCars = rentalPlanning.maxRentalCars,
      maxRentalEBikes = rentalPlanning.maxRentalEBikes,
      maxRentalMotorbikes = rentalPlanning.maxRentalMotorbikes
    } = data;
    const {currentRentalBicycles = 0, currentRentalCars = 0, currentRentalEBikes = 0, currentRentalMotorbikes = 0} = currentRentals

    const hasBicycleAvailabilities = this.state.hasBicycle && currentRentalBicycles < maxRentalBicycles;
    const hasCarAvailabilities = currentRentalCars < maxRentalCars;
    const hasEBikeAvailabilities = this.state.hasEBike && currentRentalEBikes < maxRentalEBikes;
    const hasMotorbikesAvailabilities = this.state.hasMotorbike && currentRentalMotorbikes < maxRentalMotorbikes;

    return (hasBicycleAvailabilities || hasCarAvailabilities || hasEBikeAvailabilities || hasMotorbikesAvailabilities) ? "calendar-box--available" : "calendar-box--unavailable";
  };

  isOpeningDay(day) {
    const {fetchPlanningManagement: {planningManagement = {}}} = this.props;
    const planning = planningManagement.planning || {};
    const currentWeekDay = Time.dayOfWeekAsStringUppercase(day);
    return (planning[currentWeekDay] && planning[currentWeekDay].slots && planning[currentWeekDay].slots.length > 0);
  }

  renderAvailabilities = (date, data, currentRentals, rentalPlanning) => {
    const {intl: {formatMessage}} = this.props;
    const {
      maxRentalBicycles = rentalPlanning.maxRentalBicycles,
      maxRentalCars = rentalPlanning.maxRentalCars,
      maxRentalEBikes = rentalPlanning.maxRentalEBikes,
      maxRentalMotorbikes = rentalPlanning.maxRentalMotorbikes
    } = data;
    const {currentRentalBicycles = 0, currentRentalCars = 0, currentRentalEBikes = 0, currentRentalMotorbikes = 0} = currentRentals

    if (!this.isOpeningDay(date)) {
      return null;
    }
    return (
      <div className="metric small">
        {this.state.hasCar &&
          <div>{formatMessage({id: 'rental-planning.cars.label'})}: {currentRentalCars} / {maxRentalCars}</div>
        }
        {this.state.hasMotorbike &&
          <div>{formatMessage({id: 'rental-planning.motorbikes.label'})}: {currentRentalMotorbikes} / {maxRentalMotorbikes}</div>
        }
        {this.state.hasEBike &&
          <div>{formatMessage({id: 'rental-planning.eBikes.label'})}: {currentRentalEBikes} / {maxRentalEBikes}</div>
        }
        {this.state.hasBicycle &&
          <div>{formatMessage({id: 'rental-planning.bicycles.label'})}: {currentRentalBicycles} / {maxRentalBicycles}</div>
        }
      </div>
    )
  };

  onDayChange = (date, maxRentalBicycles, maxRentalCars, maxRentalEBikes, maxRentalMotorbikes) => {
    const {planning = {}} = this.state;
    planning[date] = planning[date] || {};
    planning[date].day = date;
    planning[date].maxRentalBicycles = maxRentalBicycles;
    planning[date].maxRentalCars = maxRentalCars;
    planning[date].maxRentalEBikes = maxRentalEBikes;
    planning[date].maxRentalMotorbikes = maxRentalMotorbikes;
    this.setState({planning});
  };

  onCalendarRangeChange = (date) => {
    this.updateCalendarRange(date);
    this.setState({
      selectedDay: moment(date).format(Constants.DATE_FORMAT_API)
    });
  };

  renderDayError(error) {
    const {intl: {formatMessage},} = this.props;
    const [planningDay, field] = error.field.split('.');

    if (!planningDay.startsWith('planning')) {
      return;
    }

    const day = planningDay.match(/\[(\d{4}-\d{2}-\d{2})\]/)[1]
    return (
      <div className="alert alert--error">
        {day}: {formatMessage({id: 'rental-planning.' + field})} - {formatMessage({id: error.message}, {value: error.args})}
      </div>
    )
  }

  render() {
    const {intl: {formatMessage}, fetchRentalPlanning: {loading, rentalPlanning}, saveRentalPlanning: {error = {}}} = this.props;
    const {planning = {}, rentingManual, setRentalsModalOpen, selectedDay, hasBicycle, hasCar, hasEBike, hasMotorbike} = this.state;
    const {maxRentalBicycles, maxRentalCars, maxRentalEBikes, maxRentalMotorbikes} = rentalPlanning

    const displayCalendar = (rentalPlanning && rentalPlanning.planning) && (hasBicycle || hasCar || hasEBike || hasMotorbike);

    const errors = error.content || {};

    return (
      <section className="box rental-planning">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id: 'section.rental-planning.title'})}
          </h2>
          <div className="box-heading__button">
            {rentingManual &&
              <button onClick={this.save} type="primary" disabled={Object.keys(planning).length === 0} className="btn btn-sm btn-primary">{formatMessage({id: 'action.save'})}</button>
            }
          </div>
        </header>
        {
          (loading) ? (
            <LoadingIndicator/>
          ) : (
            <div className="box__body">
              {!displayCalendar ? (
                <div className="alert alert--error">{formatMessage({id: 'configuration.rental-planning.not-available'})}</div>
              ) : (
                <React.Fragment>
                  {Object.values(errors).map(error => this.renderDayError(error))}
                  <Calendar className="calendar--hidden-year"
                            onSelect={this.onSelectDate}
                            dateFullCellRender={this.dateFullCellRender}
                            onPanelChange={this.onCalendarRangeChange}
                            value={moment(selectedDay)}
                  />
                  <SetRentalsMenu visible={setRentalsModalOpen}
                                  onModalClose={() => this.setState({setRentalsModalOpen: false})}
                                  onModalDayChange={this.onDayChange}
                                  date={selectedDay}
                                  data={planning[selectedDay]}
                                  planning={rentalPlanning.planning[selectedDay]}
                                  hasBicycle={hasBicycle}
                                  hasCar={hasCar}
                                  hasEBike={hasEBike}
                                  hasMotorbike={hasMotorbike}
                                  maxRentalBicycles={maxRentalBicycles}
                                  maxRentalCars={maxRentalCars}
                                  maxRentalEBikes={maxRentalEBikes}
                                  maxRentalMotorbikes={maxRentalMotorbikes}
                  />
                </React.Fragment>
              )}
            </div>
          )
        }
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchRentalPlanning: state.fetchRentalPlanning,
  saveRentalPlanning: state.saveRentalPlanning,

  fetchPlanningManagement: state.fetchPlanningManagement,
  savePlanningManagement: state.savePlanningManagement,

  fetchMobility: state.fetchMobility,
  fetchMainServices: state.fetchMainServices,
  fetchRentalVehicles: state.fetchRentalVehicles,
  configurationHints: state.dealerConfigurationCheck && state.dealerConfigurationCheck.configurationHints,

});

const mapDispatchToProps = dispatch => ({
  dispatchFetchRentalPlanning: (day) => dispatch({type: 'FETCH_RENTAL_PLANNING.REQUEST', day}),
  dispatchSaveRentalPlanning: (body) => dispatch({type: 'SAVE_RENTAL_PLANNING.REQUEST', body}),
  dispatchFetchRentalVehicles: () => dispatch({type: 'FETCH_RENTAL_VEHICLES.REQUEST'})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(RentalPlanning), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
